import { SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AvatarDirective } from '../../../common/avatar/avatar.directive';

@Component({
  selector: 'sharry-people-avatar-list',
  standalone: true,
  imports: [SlicePipe, AvatarDirective],
  templateUrl: './people-avatar-list.component.html',
  styleUrls: ['./people-avatar-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PeopleAvatarListComponent {
  @Input() users: any[];
  @Input() maxLength: number;
  @Input() count: number;
  @Output() peopleClicked = new EventEmitter();
}
